module.exports = __webpack_public_path__ + "img/largeScreenTitle3.63dcdf1e.png";